import { render, staticRenderFns } from "./view-layout.m.vue?vue&type=template&id=5069780b&scoped=true"
import script from "./view-layout.m.vue?vue&type=script&lang=js"
export * from "./view-layout.m.vue?vue&type=script&lang=js"
import style0 from "./view-layout.m.vue?vue&type=style&index=0&id=5069780b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5069780b",
  null
  
)

export default component.exports